import { gql } from 'apollo-angular';

export const EditTeamMemberDocument = gql`
  mutation editTeamMember($input: EditMemberInputGraphql!) {
    editTeamMember(input: $input) {
      id
      role
      email
      user {
        id
        firstName
        lastName
        email
        avatar {
          id
          file
        }
      }
    }
  }
`;
